<div class="authentification">
    <div class="avatar"></div>
    <div class="home">
        <a routerLink="/">
            <div class="icon-home">
                <i class="glyphicon glyphicon-home"></i>
            </div>
            <span>Accueil</span>
        </a>
    </div>
    <div class="auth-content">
        <div class="text-center">
            <img class="payement" src="assets/images/payement.gif" alt="" srcset="">
        </div>
        <h1 class="text-center">Confirmation de</h1>
        <h1 class="text-center">paiement</h1>
        <p class="confirmation text-center" *ngIf="loading">Confirmation <span>.</span><span>.</span><span>.</span></p>
        <div class="confirmation-success" *ngIf="status==1">
            <div class="f-modal-alert">
                <div class="f-modal-icon f-modal-success animate">
                    <span class="f-modal-line f-modal-tip animateSuccessTip"></span>
                    <span class="f-modal-line f-modal-long animateSuccessLong"></span>
                    <div class="f-modal-placeholder"></div>
                    <div class="f-modal-fix"></div>
                </div>
            </div>
            <p class="text-center">
                Merci, Votre commande a été bien payé.
            </p>
            <a class="add-to-cart btn" routerLink="/commandes">
                <i class="flaticon-shopping"></i>
                <span>Mes commandes</span>
            </a>
        </div>
        <div class="confirmation-success" *ngIf="status==2">
            <div class="f-modal-alert">
                <div class="f-modal-icon f-modal-success animate">
                    <span class="f-modal-line f-modal-tip animateSuccessTip"></span>
                    <span class="f-modal-line f-modal-long animateSuccessLong"></span>
                    <div class="f-modal-placeholder"></div>
                    <div class="f-modal-fix"></div>
                </div>
            </div>
            <p class="text-center">
                Merci, le paiement de votre commande a déjà été effectué.
            </p>
            <a class="add-to-cart btn" routerLink="/commandes">
                <i class="flaticon-shopping"></i>
                <span>Mes commandes</span>
            </a>
        </div>
        <div class="error" *ngIf="status==3">
            Opps, le temps pour valider le paiement de votre commande a été passé.
        </div>
        <div class="error" *ngIf="error">
            Opps, Une erreur s'est produite. Veuillez réessayer plus tard.
        </div>
        <div class="error" *ngIf="status==4">
            Opps, Une erreur s'est produite. Identifiant de transaction inconnu.
        </div>
    </div>
</div>